import { useRef, useState } from 'react';
import { Button } from '@nazka/nazka.mapframe.components';
import { faPenToSquare } from '@fortawesome/pro-light-svg-icons';
import { toast } from 'react-toastify';

import { useTranslation } from '@utils/i18n/i18n.consumers';
import { MAX_IMAGE_SIZE } from '@App/app.constants';

import './editable-image.styl';

function EditableImage({
  src,
  alt = 'Story image',
  onImageChange,
}) {
  const [image, setImage] = useState();

  const fileInputRef = useRef(null);
  const { t } = useTranslation();

  const handleEditClick = () => {
    fileInputRef.current?.click();
  };

  const handleFileChange = (event) => {
    const file = event.target.files[0];

    if (file) {
      if (file.size > MAX_IMAGE_SIZE) {
        toast.error(t('Image size should be less than 10MB.'));
        return;
      }

      setImage(URL.createObjectURL(file));
      onImageChange(file);
    }
  };

  return (
    <div className="editable-image z-depth-1">
      <div className="editable-image__container">
        <img
          src={image || src}
          alt={alt}
          className="editable-image__img"
        />
        <Button
          onClick={handleEditClick}
          className="editable-image__edit-btn"
          icon={faPenToSquare}
          layout="outlined"
        >
          {t('Edit image')}
        </Button>
        <input
          ref={fileInputRef}
          type="file"
          accept="image/png, image/jpeg, image/jpg"
          onChange={handleFileChange}
          className="editable-image__file-input"
        />
      </div>
    </div>
  );
}

export default EditableImage;